import React from 'react';
import { ProcessForm } from '../production-site-split-types';
import { makeStyles, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) =>
  createStyles({
    sent: {
      color: theme.palette.primary.main,
    },
    unsent: {
      color: theme.palette.error.main,
    },
  })
);

export function StepSummaryLabel({ allValues }: { allValues?: ProcessForm }) {
  const classes = useStyles();
  const state = allValues?.isSent ? 'ODESLÁNO' : 'NEODESLÁNO';

  return (
    <>
      Stav procesu:{' '}
      <b className={allValues?.isSent ? classes.sent : classes.unsent}>
        {state}
      </b>
    </>
  );
}
